import { useQuery, useMutation, useQueryClient } from '@tanstack/react-query';
import api from '../lib/api.js';
import { useScopeKey } from './useScopeKey.js';

function buildParams(filters = {}) {
  const p = new URLSearchParams();
  if (filters.status) p.set('status', filters.status);
  const str = p.toString();
  return str ? `?${str}` : '';
}

export function useEmployees(filters = {}) {
  const scopeKey = useScopeKey();
  return useQuery({
    queryKey: ['employees', scopeKey, filters],
    queryFn: () => api.get(`/employees${buildParams(filters)}`),
    staleTime: 30_000,
    enabled: scopeKey !== 'loading',
  });
}

// Une fiche employé génère des récurrences (salaire + charges) : toute mutation
// change l'arbre prévisionnel, la projection de trésorerie et les échéances à
// venir — les quatre caches doivent tomber ensemble.
function invalidateAll(qc) {
  qc.invalidateQueries({ queryKey: ['employees'] });
  qc.invalidateQueries({ queryKey: ['forecasts', 'tree'] });
  qc.invalidateQueries({ queryKey: ['cash-flow'] });
  qc.invalidateQueries({ queryKey: ['upcoming-events'] });
}

export function useCreateEmployee() {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: (body) => api.post('/employees', body),
    onSuccess: () => invalidateAll(qc),
  });
}

export function useUpdateEmployee() {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: ({ id, ...body }) => api.patch(`/employees/${id}`, body),
    onSuccess: () => invalidateAll(qc),
  });
}

export function useDeleteEmployee() {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: (id) => api.delete(`/employees/${id}`),
    onSuccess: () => invalidateAll(qc),
  });
}
